import { useUI } from "providers/UIProvider"
import { Flex } from "@chakra-ui/react"
import Modal from "components/UI/organisms/Modal"
import CarDetailsBox from "components/UI/molecules/CarDetailsBox"
import { useCustomersContext } from "providers/CustomersProvider/CustomersProvider"
import { ICustomerVehicle } from "types/customer"

const ClientAutosModal = () => {
  const { modals, toggleModal, T } = useUI()
  const { vehicles = [] } = useCustomersContext()

  return (
    <Modal
      isOpen={modals.clientAutosModal.isOpened}
      onClose={() => toggleModal("clientAutosModal", false)}
      title={T("client_autos.title")}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "700px",
        bodyPadding: "25px 25px 48px 25px",
      }}
    >
      <>
        {vehicles.length > 0 && (
          <Flex justifyContent={"center"} alignItems="center" rowGap={"30px"} columnGap="25px" flexWrap={"wrap"}>
            {vehicles.map((vehicle: ICustomerVehicle) => (
              <CarDetailsBox
                key={vehicle.id}
                vehicle={vehicle}
              />
            ))}
          </Flex>
        )}
      </>
    </Modal>
  )
}

export default ClientAutosModal
